import type { ApiErrorBody } from '@yardpay/shared';
import { auth } from './auth';
import { runtimeConfig } from './config';
import { store } from './store';

export class ApiError extends Error {
  constructor(public status: number, public code: string, message: string, public details?: unknown) {
    super(message);
  }
}

export async function api<T>(path: string, init: { method?: string; body?: unknown; tenant?: string | null } = {}): Promise<T> {
  const token = await auth().getIdToken();
  const headers: Record<string, string> = {};
  if (token) headers.authorization = `Bearer ${token}`;
  const tenant = init.tenant === undefined ? store.getState().session.tenantId : init.tenant;
  if (tenant) headers['x-tenant-id'] = tenant;
  if (init.body !== undefined) headers['content-type'] = 'application/json';
  const res = await fetch(`${runtimeConfig().apiUrl}${path}`, {
    method: init.method ?? 'GET',
    headers,
    body: init.body !== undefined ? JSON.stringify(init.body) : undefined,
  });
  if (res.status === 204) return undefined as T;
  const ct = res.headers.get('content-type') ?? '';
  const data = ct.includes('json') ? await res.json() : await res.text();
  if (!res.ok) {
    const e = (data as ApiErrorBody)?.error;
    throw new ApiError(res.status, e?.code ?? 'INTERNAL', e?.message ?? 'Errore imprevisto', e?.details);
  }
  return data as T;
}

/** Scarica un file dall'API (es. CSV) con l'autenticazione. */
export async function download(path: string, fileName: string): Promise<void> {
  const token = await auth().getIdToken();
  const tenant = store.getState().session.tenantId;
  const res = await fetch(`${runtimeConfig().apiUrl}${path}`, {
    headers: { ...(token ? { authorization: `Bearer ${token}` } : {}), ...(tenant ? { 'x-tenant-id': tenant } : {}) },
  });
  if (!res.ok) throw new ApiError(res.status, 'INTERNAL', 'Download non riuscito');
  const url = URL.createObjectURL(await res.blob());
  const a = Object.assign(document.createElement('a'), { href: url, download: fileName });
  a.click();
  URL.revokeObjectURL(url);
}
